module.exports = __webpack_public_path__ + "static/media/UniNeueThin-Italic.6f80869c.eot";